import { PropsWithChildren } from "react";
import { Container } from "manifest-components/src/Containers";
import { BoxContainer2 } from "./BoxContainer";

export default function FullSizeBoxContainer(props: PropsWithChildren<any>) {
  return (
    <Container width={962} style={{ margin: "auto" }}>
      <BoxContainer2>{props.children}</BoxContainer2>
    </Container>
  );
}
